export default __webpack_public_path__ + "static/media/delete.f853f900.svg";